import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!window.history || !("scrollRestoration" in window.history)) return;

    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    const handleBeforeUnload = () => {
      sessionStorage.setItem("homeScrollY", String(window.scrollY));
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.history.scrollRestoration = previousRestoration;
    };
  }, []);

  useEffect(() => {
    if (pathname !== "/") return;

    const navEntry = performance.getEntriesByType("navigation")[0];
    const isReload =
      navEntry && "type" in navEntry && navEntry.type === "reload";

    if (!isReload) return;

    const savedY = sessionStorage.getItem("homeScrollY");
    if (savedY === null) return;

    const y = Number(savedY);
    if (!Number.isFinite(y)) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo(0, y);
      });
    });
  }, [pathname]);

  useEffect(() => {
    if (pathname !== "/") {
      const html = document.documentElement;
      const prevBehavior = html.style.scrollBehavior;

      html.style.scrollBehavior = "auto"; // disable smooth scrolling
      window.scrollTo(0, 0); // instant jump to top

      setTimeout(() => {
        html.style.scrollBehavior = prevBehavior; // restore original behavior
      }, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
